/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Fairuse_Section5title2Inputs */

const id_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Penyangkalan Data Bocor`)
};

const ms_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Penafian Data Bocor`)
};

const da_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Ansvarsfraskrivelse for Lækkede Data`)
};

const de_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Haftungsausschluss für durchgesickerte Daten`)
};

const en_us2_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Leaked Data Disclaimer`)
};

const es_es2_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Aviso sobre datos filtrados`)
};

const es_mx2_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Aviso sobre datos filtrados`)
};

const fil_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Disclaimer sa Na-leak na Data`)
};

const fr_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Avertissement concernant les données divulguées`)
};

const it_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Disclaimer sui dati trapelati`)
};

const hu_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Jogi nyilatkozat a kiszivárgott adatokról`)
};

const nl_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Vrijwaring gelekte gegevens`)
};

const no_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Ansvarsfraskrivelse for lekkede data`)
};

const pl_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Zastrzeżenie dotyczące wyciekłych danych`)
};

const pt_br2_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Isenção de responsabilidade de dados vazados`)
};

const pt_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Aviso sobre dados divulgados`)
};

const ro_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Declinarea responsabilității pentru date scurse`)
};

const fi_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Tietovuotoja koskeva vastuuvapauslauseke`)
};

const sv_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Ansvarsfriskrivning för läckta data`)
};

const vi_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Tuyên bố miễn trừ về dữ liệu bị rò rỉ`)
};

const tr_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Sızdırılan Veri Sorumluluk Reddi`)
};

const cs_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Prohlášení o uniklých datech`)
};

const bg_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Отказ от отговорност за изтекли данни`)
};

const ru_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Отказ от ответственности за утечку данных`)
};

const uk_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Застереження щодо витоку даних`)
};

const ar_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. إخلاء مسؤولية البيانات المسربة`)
};

const hi_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. अस्वीकरण`)
};

const th_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. ข้อจำกัดความรับผิดชอบเกี่ยวกับข้อมูลรั่วไหล`)
};

const ja_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. リークデータに関する免責事項`)
};

const zh_cn2_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. 泄露数据免责声明`)
};

const zh_hant1_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. 洩漏資料免責宣告`)
};

const ko_misc_fairuse_section5title2 = /** @type {(inputs: Misc_Fairuse_Section5title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. 유출 데이터 면책 조항`)
};

/**
* | output |
* | --- |
* | "5. Leaked Data Disclaimer" |
*
* @param {Misc_Fairuse_Section5title2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_fairuse_section5title2 = /** @type {((inputs?: Misc_Fairuse_Section5title2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Fairuse_Section5title2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_fairuse_section5title2(inputs)
	if (locale === "ms") return ms_misc_fairuse_section5title2(inputs)
	if (locale === "da") return da_misc_fairuse_section5title2(inputs)
	if (locale === "de") return de_misc_fairuse_section5title2(inputs)
	if (locale === "en-US") return en_us2_misc_fairuse_section5title2(inputs)
	if (locale === "es-ES") return es_es2_misc_fairuse_section5title2(inputs)
	if (locale === "es-MX") return es_mx2_misc_fairuse_section5title2(inputs)
	if (locale === "fil") return fil_misc_fairuse_section5title2(inputs)
	if (locale === "fr") return fr_misc_fairuse_section5title2(inputs)
	if (locale === "it") return it_misc_fairuse_section5title2(inputs)
	if (locale === "hu") return hu_misc_fairuse_section5title2(inputs)
	if (locale === "nl") return nl_misc_fairuse_section5title2(inputs)
	if (locale === "no") return no_misc_fairuse_section5title2(inputs)
	if (locale === "pl") return pl_misc_fairuse_section5title2(inputs)
	if (locale === "pt-BR") return pt_br2_misc_fairuse_section5title2(inputs)
	if (locale === "pt") return pt_misc_fairuse_section5title2(inputs)
	if (locale === "ro") return ro_misc_fairuse_section5title2(inputs)
	if (locale === "fi") return fi_misc_fairuse_section5title2(inputs)
	if (locale === "sv") return sv_misc_fairuse_section5title2(inputs)
	if (locale === "vi") return vi_misc_fairuse_section5title2(inputs)
	if (locale === "tr") return tr_misc_fairuse_section5title2(inputs)
	if (locale === "cs") return cs_misc_fairuse_section5title2(inputs)
	if (locale === "bg") return bg_misc_fairuse_section5title2(inputs)
	if (locale === "ru") return ru_misc_fairuse_section5title2(inputs)
	if (locale === "uk") return uk_misc_fairuse_section5title2(inputs)
	if (locale === "ar") return ar_misc_fairuse_section5title2(inputs)
	if (locale === "hi") return hi_misc_fairuse_section5title2(inputs)
	if (locale === "th") return th_misc_fairuse_section5title2(inputs)
	if (locale === "ja") return ja_misc_fairuse_section5title2(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_fairuse_section5title2(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_fairuse_section5title2(inputs)
	return ko_misc_fairuse_section5title2(inputs)
});
export { misc_fairuse_section5title2 as "misc.fairUse.section5Title" }